"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePnpmWorkspace = exports.parsePnpmProject = void 0;
const parse_project_1 = require("./parse-project");
Object.defineProperty(exports, "parsePnpmProject", { enumerable: true, get: function () { return parse_project_1.parsePnpmProject; } });
const parse_workspace_1 = require("./parse-workspace");
Object.defineProperty(exports, "parsePnpmWorkspace", { enumerable: true, get: function () { return parse_workspace_1.parsePnpmWorkspace; } });
//# sourceMappingURL=index.js.map